import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCalendarClock4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalendarClock4"><Path d="M20.5 9V4.5H3.5V20.5H9M7.5 4.5V2.5M16.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="17" cy="17" r="5.5" stroke="currentColor"/><Path d="M17 14.5V16.9996L19 19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalendarClock4;
